import { LeadAssignmentRuleFormModel } from '../../../../typings'
import { useField, useFormikContext } from 'formik'
import { SalesTeam } from '@user/store/salesTeam'
import { useCallback, useMemo } from 'react'

type Props = {
  name: string
  optionList: SalesTeam[]
  required?: boolean
}

export function useData(props: Props) {
  const { name, optionList, required } = props

  const {
    isSubmitting,
    values: { salesTeamIds },
  } = useFormikContext<LeadAssignmentRuleFormModel>()

  const [, { error, touched }] = useField<string[]>({
    name,
  })

  const showError =
    required !== undefined
      ? Boolean(required && error && touched)
      : Boolean(error && touched)
  const helperText = showError ? error : ''

  const initialOptions = useMemo(() => {
    if (salesTeamIds && salesTeamIds.length > 0) {
      const value = optionList.filter((x) => salesTeamIds.includes(x.id))
      if (value) return value
    }
    return []
  }, [optionList, salesTeamIds])

  const getLabel = useCallback(
    (option: SalesTeam) => `${option?.name} - ${option?.branchName}`,
    [],
  )

  const getId = useCallback((option: SalesTeam) => {
    return String(option.id)
  }, [])

  const renderSummary = useCallback((options, text: string) => {
    if (options.length === 1) {
      return options[0].label || options[0].name
    } else {
      return `${options.length} ${text}`
    }
  }, [])

  const isOptionEqual = useCallback(
    (optionA: SalesTeam, optionB: SalesTeam) => optionA.id === optionB.id,
    [],
  )

  const matchFilter = useCallback((option, _getLabel, searchValue) => {
    const searchIn = [option.name]
    return searchIn.some((entry) =>
      entry.toLowerCase().includes(searchValue.toLowerCase()),
    )
  }, [])

  return {
    items: optionList,
    showError,
    helperText,
    isSubmitting,
    initialOptions,
    renderSummary,
    getId,
    getLabel,
    matchFilter,
    isOptionEqual,
  }
}
